import { AppDivider } from '../../../../../../../../../../ui/AppDivider';

export function CellPopupDivider({ color = '#2E2D3A' }) {
  return <AppDivider type='vertical' innerProps={{ style: { background: color } }} />;
}
